import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import ContactStrip from '@/components/feature/ContactStrip';
import HomeHero from './components/HomeHero';
import DivisionsSection from './components/DivisionsSection';

export default function Home() {
  return (
    <main className="min-h-screen">
      <SiteHeader />
      <HomeHero />
      <DivisionsSection />
      <ContactStrip
        email="info@penlandllc.com"
        title="Contact Penland LLC"
        description="Questions about a division, a project, or a quote? Reach out to Penland LLC and we will respond during business hours."
      />
      <SiteFooter />
    </main>
  );
}